import { useEffect } from "react";

/**
 * Injects a JSON-LD <script> block into <head> while the component is
 * mounted, then removes it on unmount.
 */
const useJsonLd = (schema: object | null): void => {
    useEffect(() => {
        if (!schema) return;

        const script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);

        return () => {
            if (document.head.contains(script)) {
                document.head.removeChild(script);
            }
        };
    }, [schema]);
};

export default useJsonLd;
